import { defineNuxtPlugin } from "#app";
import { storeToRefs } from "pinia";
import { useCheckEditorPermission } from "./composables/useCheckEditorPermission.mjs";
import { useFetchLiveEditorValues } from "./composables/useFetchLiveEditorValues.mjs";
import { useLiveEditorStore } from "./stores/useLiveEditorStore.mjs";
import { useUser } from "./composables/useUser.mjs";
export default defineNuxtPlugin(async (nuxtApp) => {
  const { current_user } = await useUser();
  const { canLiveEditor } = await useCheckEditorPermission(current_user.value);
  const { fetchDataLive, liveEditorValues } = await useFetchLiveEditorValues(canLiveEditor.value, current_user.value);
  const { data_live_editor_async } = storeToRefs(useLiveEditorStore());
  nuxtApp.vueApp.provide("is_edit", canLiveEditor.value);
  nuxtApp.vueApp.provide("fetch_data_live", fetchDataLive);
  nuxtApp.vueApp.provide("current_user", current_user.value);
  nuxtApp.vueApp.provide("data_live_editor", liveEditorValues);
  nuxtApp.vueApp.provide("data_live_editor_prased", data_live_editor_async.value);
});
